export default "__VITE_ASSET__8N1W4d40__"